import React, { useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import SelectComponent from "../../../components/Tenant/SelectComponent/SelectComponent";
import InputComponent from "../../../components/Tenant/InputComponent/InputComponent";
import Wheels from "../../../components/Tenant/Wheel/Wheel";
import MultiSelectComponent from "../../../components/Tenant/MultiSelectComponent/MultiSelectComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { States } from "../../../utils/getStates";
import { toast } from "react-hot-toast";
import {
  useAddWheelMutation,
  useGetWheelByCampaignIdMutation,
  useUpdateWheelByIdMutation,
} from "../../../features/tenant/wheel/wheelApi";
import {
  useAddWheelRewardsMutation,
  useGetWheelRewardsByWheelIdMutation,
  useUpdateWheelRewardsByIdMutation,
  useCreateAllocationMutation,
} from "../../../features/tenant/wheelRewards/wheelRewardsApi";
import {
  OutlinedInput,
  InputLabel,
  MenuItem,
  Select,
  Modal,
  Backdrop,
  Fade,
  Box,
  Typography,
} from "@mui/material";
import { useGetAppUserTypesMutation } from "../../../features/tenant/appUsers/appUsersApi";
import { useFetchCouponsBrandMutation } from "../../../features/tenant/staticCoupons/staticCouponsApi";
import "./Wheel.css";
import {
  useGetWheelCampaignByIdMutation,
  useUpdateWheelCampaignByIdMutation,
  useAddWheelCampaignMutation,
} from "../../../features/tenant/wheelCampaign/wheelCampaignApi";
import { FaCloudUploadAlt, FaEye, FaListAlt, FaPalette, FaGift, FaMapMarkedAlt, FaChevronRight, FaChevronLeft, FaTimes, FaCog } from "react-icons/fa";
import { useUploadSingleFileMutation } from "../../../features/admin/imageUpload/imageUploadApi";


const type = [
  {
    id: 1,
    name: "Not Applicable",
  },
  {
    id: 2,
    name: "Before Spin",
  },
  {
    id: 3,
    name: "After Spin",
  },
];

const Wheel = () => {
  const location = useLocation();
  const allStates = States;
  const [states, setStates] = useState([allStates[0]]);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [budget, setBudget] = useState(0);
  const [selectedType, setSelectedType] = useState(type[0]);

  const [elements, setElements] = useState([]);
  const [lableName, setLableName] = useState("");
  const [name, setName] = useState("");
  const [inputLength, setInputLength] = useState("");
  const [inputType, setInputType] = useState("");
  const [required, setRequired] = useState(false);
  const [reRender, setReRender] = useState(false);
  const [selectOption, setSelectOptions] = useState([]);
  const [newUserValue, setNewUserValue] = useState("");
  const [open, setOpen] = useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const steps = [
    { title: "Campaign Details", icon: <FaListAlt /> },
    { title: "Design & Segment", icon: <FaPalette /> },
    { title: "Rewards Logic", icon: <FaGift /> },
    { title: "Rules & Allocation", icon: <FaMapMarkedAlt /> },
  ];

  useEffect(() => {
    const handleNewElementAddition = () => {
      let newElementObj = {
        label: lableName,
        name: name,
        type: inputType,
        required: required,
        maxLength: inputLength,
        options: selectOption,
      };

      let oldOptions = elements;
      oldOptions.push(newElementObj);
      setElements(oldOptions);
      console.log("added");

      console.log(oldOptions);
    };
    if (lableName !== "" && inputType !== "" && inputLength !== "") {
      handleNewElementAddition();
      setName("");
      setLableName("");
      setInputLength("");
      setRequired(false);
      setInputType("");
    }
  }, [reRender]);

  const handleInputTypeChange = (e) => {
    setInputType(e.target.value);
  };

  const removeFromSelectOptions = (e, key) => {
    console.log(key);
    let oldValues = [...selectOption];
    oldValues = oldValues.filter((user) => user != key);
    setSelectOptions(oldValues);
  };

  const handleDeleteElement = (e, eIdx) => {
    let oldElements = elements;
    oldElements = oldElements.filter((ele, idx) => idx !== eIdx);
    setElements(oldElements);
    setReRender((old) => !old);
  };

  const [wc_id, setWc_id] = useState();
  const [wheelId, setWheelId] = useState();
  const color = JSON.parse(sessionStorage.getItem("vendorTheme")).theme
    .primary_color;
  const [rewardsSbmt, setRewardsSbmt] = useState(true);
  const [userTypes, setUserTypes] = useState(null);
  const [edit, setEdit] = useState(false);
  const [openTab, setOpenTab] = React.useState(1);
  const [names, setUserNames] = useState([]);
  const [status, setStatus] = useState([
    { id: 0, name: "Deleted" },
    { id: 1, name: "Active" },
    { id: 2, name: "InActive" },
  ]);
  const [data, setData] = useState([
    { option: "" },
    { option: "" },
    { option: "" },
    { option: "" },
    { option: "" },
    { option: "" },
    { option: "" },
    { option: "" },
  ]);

  // const [primaryBackgroundColor, setPrimaryBackgroundColor] =
  //   useState("#3e3e3e");
  // const [secondaryBackgroundColor, setSecondaryBackgroundColor] =
  //   useState("#df3428");
  // const [primaryTextColor, setPrimaryTextColor] = useState("#ffffff");
  // const [secondaryTextColor, setSecondaryTextColor] = useState("#3e3e3e");
  // const [outerBorderColor, setOuterBorderColor] = useState("#000000");
  const [renderTimes, setrenderTimes] = useState([]);
  const [images, setImages] = useState([]);
  const [couponList, setCouponList] = useState([]);
  const [picture, setPicture] = useState(null);
  const [pictureFile, setPictureFile] = useState(null);

  const navigate = useNavigate();
  const [rewardLengths, setRewardLength] = useState(
    Array.from({ length: 9 }, (_, i) => ({ id: i + 1, name: i + 2 }))
  );
  const [types, setTypes] = useState([
    {
      id: 1,
      name: "Filler",
    },
    {
      id: 2,
      name: "Gift",
    },
    {
      id: 3,
      name: "Cashback",
    },
    {
      id: 4,
      name: "Points",
    },
    // {
    //   id: 3,
    //   name: "Coupon",
    // },
    // {
    //   id: 4,
    //   name: "Point",
    // },
  ]);

  const [reward, setReward] = useState({
    id: 1,
    name: 2,
  });

  const wheelTypes = [
    { id: "1", name: "Probability" },
    { id: "2", name: "Fixed Prize" },
  ];

  const [wheelType, setWheelType] = useState({
    id: 0,
    name: "Set Wheel Type",
  });

  const [fixedReward, setFixedReward] = useState({
    id: 0,
    name: "Select Reward",
  });

  const obj = {
    id: "",
    wc_id: wc_id,
    w_id: wheelId,
    type: "",
    name: "",
    status: "",
    windex: "",
    startDate: startDate,
    endDate: endDate,
    offsetx: 0,
    offsety: 0,
    probability: 0,
    quantity: 10,
    image: "",
    points: 0,
  };

  const [allocationData, setAllocationData] = useState([]);

  const validateForm = () => {
    const errors = [];

    renderTimes.forEach((obj, index) => {
      if (obj.type === "") {
        errors.push("Some field Missed");
        toast.error(`Type is required `, { id: "TypeError" });
      }
      if (obj.status === "") {
        errors.push("Some field Missed");
        toast.error(`Status is required `, { id: "NameError" });
      }
      if (obj.windex === "") {
        errors.push("Some field Missed");
        toast.error(`Index is required `, { id: "indexError" });
      }
    });

    return errors.length === 0;
  };

  const validateStep4 = () => {
    const errors = [];
    let sum = 0;

    renderTimes.forEach((obj, index) => {
      if (!obj.probability || obj.probability === 0) {
        errors.push("Probability is required");
        toast.error(`Probability is required for segment ${index + 1}`, { id: "ProbabilityError" });
      }
      if (!obj.startDate) {
        errors.push("Start Date is required");
        toast.error(`Start Date is required for segment ${index + 1}`, { id: "StartDateError" });
      }
      if (!obj.endDate) {
        errors.push("End Date is required");
        toast.error(`End Date is required for segment ${index + 1}`, { id: "EndDateError" });
      }

      sum += Number(obj.probability) || 0;
    });

    if (sum > 100) {
      errors.push("Sum of probabilities cannot exceed 100");
      toast.error(`Sum of probabilities cannot exceed 100`, { id: "SumError" });
    }

    return errors.length === 0;
  };

  const stateChange = (index, key, value) => {
    const updatedArray = renderTimes.map((obj, i) => {
      if (i === index) {
        return { ...obj, [key]: value };
      }
      return obj;
    });
    console.log(key, updatedArray);
    setrenderTimes(updatedArray);
  };

  const [
    fetchcouponBrands,
    {
      data: couponBrandList,
      isLoading: couponBrandIsLoading,
      error: couponBrandError,
    },
  ] = useFetchCouponsBrandMutation();

  const [
    addWheel,
    {
      data: addWheelData,
      isLoading: addWheelIsLoading,
      isError: addWheelIsError,
      error: addWheelError,
    },
  ] = useAddWheelMutation();

  const [
    addWheelRewards,
    {
      data: addWheelRewardsData,
      isLoading: addWheelRewardsIsLoading,
      isError: addWheelRewardsIsError,
      error: addWheelRewardsError,
    },
  ] = useAddWheelRewardsMutation();

  // useUpdateWheelByIdMutation
  const [
    UpdateWheelById,
    {
      data: updateWheelByIdData,
      isLoading: updateWheelByIdIsLoading,
      isError: updateWheelByIdIsError,
      error: updateWheelByIdError,
    },
  ] = useUpdateWheelByIdMutation();

  const [
    getWheelByCampaignId,
    {
      data: getWheelByCampaignIdData,
      isLoading: getWheelByCampaignIdIsLoading,
      isError: getWheelByCampaignIdIsError,
      error: getWheelByCampaignIdError,
    },
  ] = useGetWheelByCampaignIdMutation();

  const [
    GetWheelCampaignById,
    {
      data: GetWheelCampaignByIdData,
      isLoading: GetWheelCampaignByIdIsLoading,
      isError: GetWheelCampaignByIdIsError,
      error: GetWheelCampaignByIdError,
    },
  ] = useGetWheelCampaignByIdMutation();

  const [
    UpdateWheelCampaignById,
    {
      data: UpdateWheelCampaignByIdData,
      isLoading: UpdateWheelCampaignByIdIsLoading,
      isError: UpdateWheelCampaignByIdIsError,
      error: UpdateWheelCampaignByIdError,
    },
  ] = useUpdateWheelCampaignByIdMutation();

  const [
    addWheelCampaign,
    {
      data: addWheelCampaignData,
      isLoading: addWheelCampaignIsLoading,
      isError: addWheelCampaignIsError,
      error: addWheelCampaignError,
    },
  ] = useAddWheelCampaignMutation();

  useEffect(() => {
    if (addWheelCampaignData) {
      const id = addWheelCampaignData?.body?.id ?? addWheelCampaignData?.body?.wheel_campaign_id ?? addWheelCampaignData?.id;
      if (id) {
        setWc_id(id);
        toast.success("Wheel Campaign Created Successfully");
        setOpenTab(2);
      }
    }
    if (addWheelCampaignIsError) {
      toast.error("Error creating campaign");
    }
  }, [addWheelCampaignData, addWheelCampaignIsError]);

  const handleCreateWheelCampaign = (e) => {
    e.preventDefault();
    const finalStates = states.map((st) => st.name);
    addWheelCampaign({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      data: {
        title: title,
        description: description,
        start_date: startDate,
        end_date: endDate,
        budget: String(budget),
        states: finalStates,
        status: "2",
        feedback_form: selectedType.id,
        form_template: JSON.stringify(elements),
        scan_per_ticket: 0,
      },
    });
  };

  const [
    getWheelRewardsByWheelId,
    {
      data: getWheelRewardsByWheelIdData,
      isLoading: getWheelRewardsByWheelIdIsLoading,
      isError: getWheelRewardsByWheelIdIsError,
      error: getWheelRewardsByWheelIdError,
    },
  ] = useGetWheelRewardsByWheelIdMutation();

  const [
    getAppUserTypes,
    {
      data: getAppUserTypesData,
      isLoading: getAppUserTypesIsLoading,
      error: getAppUserTypesIsError,
      isError: getAppUserTypesError,
    },
  ] = useGetAppUserTypesMutation();

  const [
    UpdateWheelRewardsById,
    {
      data: updateWheelRewardsByIdData,
      isLoading: updateWheelRewardsByIdIsLoading,
      error: updateWheelRewardsByIdIsError,
      isError: updateWheelRewardsByIdError,
    },
  ] = useUpdateWheelRewardsByIdMutation();

  useEffect(() => {
    if (updateWheelRewardsByIdData) {
      toast.success("Rewards Updated Succesfully");
      return;
    }
    if (updateWheelRewardsByIdError) {
      toast.error("Error in Updaing Rewards");
    }
  }, [updateWheelRewardsByIdData, updateWheelRewardsByIdError]);

  const [
    createAllocation,
    {
      data: createAllocationData,
      isLoading: createAllocationIsLoading,
      isError: createAllocationIsError,
      error: createAllocationError,
    },
  ] = useCreateAllocationMutation();

  useEffect(() => {
    if (createAllocationData) {
      toast.success("Allocation Created Successfully");
    }
    if (createAllocationIsError) {
      toast.error("Error in Creating Allocation");
    }
  }, [createAllocationData, createAllocationIsError])

  const [
    uploadImage,
    {
      data: uploadImageData,
      isLoading: uploadImageIsLoading,
      error: uploadImageError,
    },
  ] = useUploadSingleFileMutation();

  const uploadImageFunc = (file, type) => {
    const formData = new FormData();
    formData.append("image", file[0]);
    uploadImage({
      body: formData,
    });
  };

  useEffect(() => {
    if (uploadImageData) {
      // console.log(uploadImageData.body[0], logoType);
      setPicture(uploadImageData.body.fileLink);
    }
    if (uploadImageError) {
      toast.error("image upload failed");
      console.log("Image upload failed");
    }
  }, [uploadImageData, uploadImageError, uploadImageIsLoading]);

  const getAllWheelRewardsFun = () => {
    getWheelRewardsByWheelId({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      id: wheelId,
      limit: 10,
      offset: 0,
    });

    // fetchcouponBrands({
    //   token: sessionStorage.getItem("access_token"),
    //   tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    // });
  };

  const getWheelCampaignById = () => {
    GetWheelCampaignById({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      id: wc_id,
    });

    // fetchcouponBrands({
    //   token: sessionStorage.getItem("access_token"),
    //   tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    // });
  };

  // GetWheelCampaignById
  useEffect(() => {
    if (addWheelRewardsData) {
      toast.success("Reward Added Sucessfully");
      navigate(-1);
      return;
    }
    if (addWheelRewardsIsError) {
      toast.error("Error in adding Reward!");
      return;
    }
  }, [addWheelRewardsData, addWheelRewardsIsError]);

  useEffect(() => {
    if (couponBrandList) {
      console.log(couponBrandList);
      const arr = [];
      for (let i = 0; i < couponBrandList?.body?.length; i++) {
        const element = couponBrandList.body[i];
        const obj = { id: i, name: element.brand, qty: element.count };
        arr.push(obj);
      }
      setCouponList(arr);
    }
  }, [couponBrandList, couponBrandError]);

  useEffect(() => {
    getAppUserTypes({
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    });
  }, []);

  useEffect(() => {
    if (wheelId) getAllWheelRewardsFun();
  }, [wheelId]);

  useEffect(() => {
    if (getWheelRewardsByWheelIdData?.body?.gifts?.length) {
      const sortedGifts = [...getWheelRewardsByWheelIdData.body.gifts].sort(
        (a, b) => a.windex - b.windex,
      );

      // Build renderTimes directly from API data.
      // Previously this did renderTimes.map(...) but renderTimes starts as []
      // so the map produced nothing and rewards always appeared empty.
      const updatedRenderTimes = sortedGifts.map((responseObj) => ({
        id: responseObj.id,
        wc_id: responseObj.wc_id,
        w_id: responseObj.w_id,
        windex: responseObj.windex,
        probability: responseObj.chance,
        type: responseObj.type,
        status: responseObj.status,
        startDate: responseObj.start_date.slice(0, 10),
        endDate: responseObj.end_date.slice(0, 10),
        offsetx: responseObj.offsetx,
        offsety: responseObj.offsety,
        quantity: responseObj.quantity,
        points: responseObj.points,
        price: responseObj.price,
        name: responseObj.name,
        image: responseObj.image,
        coupon_type: responseObj.coupon_type || "",
        font_size: responseObj.font_size || "",
        is_reward: responseObj.is_reward || "0",
        locations: responseObj.locations || [],
        total: responseObj.total ?? 0,
        available: responseObj.available ?? 0,
        city: responseObj.city || "Random",
        district: responseObj.district || "Select All",
        state: (() => {
          try {
            const parsed = JSON.parse(responseObj.state);
            if (Array.isArray(parsed)) {
              return parsed.map(s => typeof s === "string" ? { name: s } : s);
            }
          } catch (e) { }
          return [{ id: 0, name: "Random" }];
        })(),
      }));

      console.log("updatedRenderTimes", updatedRenderTimes);
      setrenderTimes(updatedRenderTimes);

      // Explicitly initialize Allocation Data using the exact API values
      setAllocationData(updatedRenderTimes.map(reward => ({
        id: reward.id,
        windex: reward.windex,
        chance: reward.probability || 0,
        state: reward.state || [{ id: 0, name: "Random" }],
        city: reward.city || "Random",
        total: reward.total ?? 0,
        available: reward.available ?? 0,
        district: reward.district || "Select All",
      })));

      setRewardsSbmt(false);
    }
  }, [getWheelRewardsByWheelIdData]);

  const updateWheelRewards = (e) => {
    e.preventDefault();



    if (validateForm()) {
      renderTimes.forEach((obj, index) => {
        const formData = new FormData();
        Object.entries(obj).forEach(([key, value]) => {
          formData.append(`${key}`, value);
        });

        UpdateWheelRewardsById({
          token: sessionStorage.getItem("access_token"),
          tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
          id: obj.id,
          data: formData,
        });

        formData.delete("*");
      });
    }
  };

  useEffect(() => {
    if (getAppUserTypesData?.body) {
      setUserTypes(getAppUserTypesData.body);
    }
  }, [getAppUserTypesData]);

  const getWheelByCampaignIdFun = () => {
    getWheelByCampaignId({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      id: wc_id,
      limit: 10,
      offset: 0,
    });
  };

  useEffect(() => {
    if (wc_id) {
      getWheelByCampaignIdFun();
    }
  }, [wc_id]);

  const doesValueExist = (array, value) => {
    for (let i = 0; i < array?.length; i++) {
      if (array[i].user_type == value || array[i].name == value) {
        return i;
      }
    }
    return -1;
    // return array.some((obj) => Object.values(obj).includes(value));
  };

  // console.log("reward", reward)

  useEffect(() => {
    console.log("getWheelByCampaignIdData", getWheelByCampaignIdData?.body);

    if (getWheelByCampaignIdData?.body?.length) {
      setWheelId(getWheelByCampaignIdData.body[0].id);
      setReward({
        ...reward,
        name: getWheelByCampaignIdData.body[0].reward_count,
      });
      // setPrimaryBackgroundColor(getWheelByCampaignIdData.body[0].bg_color);
      // setSecondaryBackgroundColor(
      //   getWheelByCampaignIdData.body[0].bg_alt_color,
      // );
      // setPrimaryTextColor(getWheelByCampaignIdData.body[0].font_color);
      // setSecondaryTextColor(getWheelByCampaignIdData.body[0].font_alt_color);
      // setOuterBorderColor(getWheelByCampaignIdData.body[0].line_color);
      // setFontSize(getWheelByCampaignIdData.body[0].font_size);
      setPicture(getWheelByCampaignIdData.body[0].wheel_image);
      if (getWheelByCampaignIdData.body[0].wheel_type == "1") {
        setWheelType(wheelTypes[0]);
      } else if (getWheelByCampaignIdData.body[0].wheel_type == "2") {
        setWheelType(wheelTypes[1]);
      }

      // console.log("user types", userTypes);

      if (
        getWheelByCampaignIdData?.body[0]?.user_type_id?.length &&
        userTypes?.length > 0
      ) {
        const arr = [];
        for (
          let i = 0;
          i < getWheelByCampaignIdData?.body[0]?.user_type_id?.length;
          i++
        ) {
          const f = userTypes.filter(
            (user) =>
              user.user_type_id ==
              getWheelByCampaignIdData?.body[0]?.user_type_id[i],
          );
          // console.log("f",f)
          if (f.length > 0) {
            arr.push(f[0]);
          }
        }
        // console.log("arr", arr);
        setUserNames(arr);
      }

      setEdit(true);
    }
  }, [getWheelByCampaignIdData, userTypes]);

  useEffect(() => {
    if (getWheelByCampaignIdData?.body?.length && renderTimes.length > 0) {
      console.log("rendertimes ", renderTimes, getWheelByCampaignIdData.body[0]);

      const f = renderTimes.filter(
        (gift) =>
          gift.id ==
          getWheelByCampaignIdData?.body[0]?.wheel_fixed_reward
      );
      if (f.length > 0)
        setFixedReward(f[0]);
    }
  }, [renderTimes, getWheelByCampaignIdData])


  useEffect(() => {
    if (addWheelData) {
      toast.success("Wheel  Added Successfully !!");
      getWheelByCampaignIdFun();
    }
    if (addWheelError) {
      toast.error("Error in Creating Wheel ");
    }
  }, [addWheelData, addWheelError]);

  useEffect(() => {
    const data = location.state;

    console.log("data", data);

    if (!data) {
      // Create mode
      return;
    }

    if (data?.id) {
      setWc_id(data.id);
    }

    if (data?.title) {
      setTitle(data.title);
    }
    if (data?.states?.length) {
      console.log("all states ", allStates);

      console.log("states here", data?.states);
      const finalStates = [];

      data.states.forEach((state) => {
        const a = allStates.filter((each) => each.name === state);
        finalStates.push(a[0]);
      });

      console.log("finalStates here", finalStates);

      // const parsedStates = data.states
      //   .map((stateJson, index) => {
      //     try {
      //       console.log("here", stateJson)
      //       const stateObject = JSON.parse(stateJson);
      //       return { id: stateObject.id, name: stateObject.name };
      //     } catch (error) {
      //       console.error(`Error parsing state at index ${index}:`, error);
      //       return null;
      //     }
      //   })
      //   .filter((state) => state !== null);
      setStates(finalStates);
    }
    if (data?.description) {
      setDescription(data.description);
    }
    if (data?.start_date) {
      data.start_date = data.start_date.slice(0, 10);
      setStartDate(data.start_date);
    }
    if (data?.end_date) {
      data.end_date = data.end_date.slice(0, 10);
      setEndDate(data.end_date);
    }
    if (data?.budget) {
      setBudget(data.budget);
    }

    if (data?.feedback_form) {
      setSelectedType(type[Number(data.feedback_form - 1)]);
    }

    if (data?.form_template) {
      setElements(data.form_template);
    }
  }, [location.state]);

  const handleAddWheel = (e) => {
    e.preventDefault();
    if (getWheelByCampaignIdData?.body?.length) {
      toast.error("Wheel Already Exists !");
      return;
    }
    if (wheelType.id == 0) {
      toast.error("Select Wheel Type", {
        id: "wheel_type",
      });
      return;
    }
    const userTypeIds = names.map((obj) => obj.user_type_id);
    const userTypeNames = names.map((obj) => obj.user_type);
    addWheel({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      data: {
        wc_id,
        reward_count: reward.name,
        // bg_color: primaryBackgroundColor,
        // bg_alt_color: secondaryBackgroundColor,
        // font_color: primaryTextColor,
        // font_alt_color: secondaryTextColor,
        // line_color: outerBorderColor,
        // font_size: fontSize,
        wheel_type: wheelType,
        user_type: userTypeNames,
        user_type_id: userTypeIds,
        wheel_image: picture,
      },
    });
    getWheelByCampaignIdFun();
  };

  // UpdateWheelCampaignById

  const updateWheelCampaign = (e) => {
    e.preventDefault();
    console.log("states", states);
    const finalStates = states.map((st) => st.name);
    // return;
    UpdateWheelCampaignById({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      id: wc_id,
      data: {
        title: title,
        description: description,
        start_date: startDate,
        end_date: endDate,
        budget: budget,
        states: finalStates,
        feedback_form: selectedType.id,
        form_template: JSON.stringify(elements),
      },
    });
  };

  // getWheelCampaignById
  useEffect(() => {
    if (UpdateWheelCampaignByIdData) {
      getWheelCampaignById();
    }
    if (UpdateWheelCampaignByIdData) {
      toast.success("Wheel Campaign Updated Successfully");
      navigate(-1);
      return;
    }
    if (UpdateWheelCampaignByIdError) {
      toast.error("Wheel Campaign Updated Successfully");
      return;
    }
  }, [UpdateWheelCampaignByIdData, UpdateWheelCampaignByIdError]);

  const updateWheel = (e) => {
    e.preventDefault();
    if (wheelType.id == 0) {
      toast.error("Select Wheel Type", {
        id: "wheel_type",
      });
      return;
    }
    console.log("wheel_fixed_reward", fixedReward);
    // return;

    const userTypeIds = names.map((obj) => obj.user_type_id);
    const userTypeNames = names.map((obj) => obj.user_type);

    UpdateWheelById({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      id: wheelId,
      data: {
        wc_id,
        reward_count: reward.name,
        // bg_color: primaryBackgroundColor,
        // bg_alt_color: secondaryBackgroundColor,
        // font_color: primaryTextColor,
        // font_alt_color: secondaryTextColor,
        // line_color: outerBorderColor,
        // font_size: fontSize,
        wheel_type: wheelType.id,
        user_type: userTypeNames,
        user_type_id: userTypeIds,
        wheel_image: picture,
        wheel_fixed_reward: fixedReward?.id ? fixedReward.id : -1,
      },
    });
    getAllWheelRewardsFun();
  };

  const handleAllocationChange = (index, key, value) => {
    let newValue = value;
    if (key === "state" && Array.isArray(value)) {
      const isRandomSelected = value.some((s) => s.name === "Random");
      const prevStates = allocationData[index].state || [];
      const wasRandomSelected = Array.isArray(prevStates) && prevStates.some((s) => s.name === "Random");

      if (isRandomSelected && !wasRandomSelected) {
        // "Random" was just selected, select all
        newValue = [{ id: 0, name: "Random" }, ...allStates];
      } else if (!isRandomSelected && wasRandomSelected) {
        // "Random" was deselected, clear all
        newValue = [];
      } else if (isRandomSelected && value.length < allStates.length + 1) {
        // One of the states was deselected, remove "Random" if not all states are selected
        newValue = value.filter((s) => s.name !== "Random");
      }
    }

    const updatedAllocation = allocationData.map((item, i) => {
      if (i === index) {
        return { ...item, [key]: newValue };
      }
      return item;
    });
    setAllocationData(updatedAllocation);
  };

  const handleFinish = async (e) => {
    e.preventDefault();
    
    // Validate step 4 fields before proceeding
    if (!validateStep4()) {
      return;
    }
    
    if (allocationData.length === 0) {
      toast.error("No rewards to allocate!");
      return;
    }

    try {
      // Ensure all rewards have been successfully saved to DB (they must have an ID)
      const hasUnsavedRewards = allocationData.some(a => !a.id);
      if (hasUnsavedRewards) {
        toast.error("Please click 'Save Rewards' on the previous tab before publishing!");
        return;
      }

      for (const allocation of allocationData) {
        if (allocation.id) {
          // Read probability and quantity from renderTimes (where Reward Logic inputs write to)
          const rewardEntry = renderTimes.find((r) => r.windex === allocation.windex) || {};
          const payload = {
            wc_id: wc_id,
            wr_id: allocation.id,
            start_date: startDate,
            end_date: endDate,
            chance: Number(rewardEntry.probability ?? allocation.chance ?? 0),
            state: Array.isArray(allocation.state)
              ? JSON.stringify(allocation.state.map((s) => s.name))
              : allocation.state,
            district: allocation.district,
            city: "Random",
            total: Number(allocation.total ?? 0),
            available: Number(allocation.available ?? 0),
            panel_uid: JSON.parse(sessionStorage.getItem("vendorData")).id,
            panel_name: JSON.parse(sessionStorage.getItem("vendorData")).name,
            user_type: "",
            user_id: 0
          };
          await createAllocation({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            data: payload,
          }).unwrap();
        }
      }
      toast.success("Campaign Published Successfully!");
      navigate(-1);
    } catch (error) {
      console.error("Allocation failed", error);
    }
  };

  useEffect(() => {
    if (updateWheelByIdData) {
      toast.dismiss();
      toast.success("Wheel Updated Successfully", { id: "updateWheelByIdData" });
      console.log("Wheel Updated Successfully");
      return;
    }
    if (updateWheelByIdError) {
      toast.dismiss();
      toast.error("Something went wrong", { id: "updateWheelByIdError" });
      console.log("updateWheelByIdError", updateWheelByIdError);
    }
  }, [updateWheelByIdData, updateWheelByIdError]);

  const handleAddRewards = (e) => {
    e.preventDefault();
    if (validateForm()) {
      renderTimes.forEach((obj, index) => {
        const formData = new FormData();
        
        // Force inject the latest state variables, overriding stale undefined values in obj
        formData.append("wc_id", wc_id);
        formData.append("w_id", wheelId);

        Object.entries(obj).forEach(([key, value]) => {
          if (key !== "wc_id" && key !== "w_id") {
            formData.append(`${key}`, value);
          }
        });

        addWheelRewards({
          token: sessionStorage.getItem("access_token"),
          tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
          data: formData,
        });

        // Clear out the formData for safety (not strictly necessary here as it gets recreated in loop)
      });
    }

    getAllWheelRewardsFun();
  };

  useEffect(() => {
    const targetLength = Number(reward.name || 2);
    setrenderTimes((prev) => {
      if (prev.length === targetLength && prev.length > 0) return prev; // Do nothing if already correct size

      // Map over target length and preserve existing objects if they exist
      return Array.from({ length: targetLength }, (_, i) => {
        if (prev[i]) {
          // Preserve existing reward data
          return { ...prev[i], windex: i };
        }
        // Fallback to empty object if out of bounds (user increased wheel size)
        return { ...obj, windex: i };
      });
    });

    // Also explicitly resize Allocation Data, preserving existing rules
    setAllocationData((prev) => {
      const p = prev || [];
      if (p.length === targetLength && p.length > 0) return p;
      return Array.from({ length: targetLength }, (_, i) => {
        if (p[i]) return { ...p[i], windex: i };
        return {
          id: undefined,
          windex: i,
          chance: 0,
          state: [{ id: 0, name: "Random" }],
          city: "Random",
          total: 0,
          available: 0,
          district: "Select All",
        };
      });
    });
  }, [reward.name]);

  // const [backgroundColor, setBackgroundColour] = useState([
  //   primaryBackgroundColor,
  //   secondaryBackgroundColor,
  // ]);
  // const [textColors, setTextColours] = useState([
  //   primaryTextColor,
  //   secondaryTextColor,
  // ]);

  // const handlePrimaryBackgroundColorChange = (event) => {
  //   const selectedColor = event.target.value;
  //   setPrimaryBackgroundColor(selectedColor);
  // };

  // const handleFontChange = (event) => {
  //   setFontSize(event.target.value);
  // };

  // const handleSecondaryBackgroundColorChange = (event) => {
  //   const selectedColor = event.target.value;
  //   setSecondaryBackgroundColor(selectedColor);
  // };

  // const handlePrimaryTextColorChange = (event) => {
  //   const selectedColor = event.target.value;
  //   setPrimaryTextColor(selectedColor);
  // };

  // const handleSecondaryTextColorChange = (event) => {
  //   const selectedColor = event.target.value;
  //   setSecondaryTextColor(selectedColor);
  // };

  // useEffect(() => {
  //   setTextColours([primaryTextColor, secondaryTextColor]);
  // }, [primaryTextColor, secondaryTextColor]);

  // useEffect(() => {
  //   setBackgroundColour([primaryBackgroundColor, secondaryBackgroundColor]);
  // }, [primaryBackgroundColor, secondaryBackgroundColor]);

  useEffect(() => {
    if (reward && reward.name) {
      const newData = Array.from({ length: +reward.name }, () => ({
        option: "",
      }));
      setData(newData);
    }
  }, [reward]);

  // console.log("names", names);

  return (
    <div className="w-full  flex flex-col items-center justify-center">
      <div className="w-full min-h-screen bg-gray-100">
        <div className="god-header">
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-3xl font-bold mb-1">
                {!edit ? "Campaign Creator" : "Edit Campaign"}
              </h1>
              <p className="text-white/80 text-sm">Configure your premium spin-the-wheel experience</p>
            </div>
            <LinksComponent />
          </div>
        </div>

        <div className="p-3 max-w-7xl mx-auto">
          <div className="glass-panel p-8 mt-4">
            {/* Custom Stepper */}
            <div className="stepper-container">
              <div className="stepper-line">
                <div
                  className="stepper-line-progress"
                  style={{ width: `${((openTab - 1) / (steps.length - 1)) * 100}%` }}
                ></div>
              </div>
              {steps.map((step, idx) => (
                <div
                  key={idx}
                  className={`step-item ${openTab === idx + 1 ? 'active' : ''} ${openTab > idx + 1 ? 'completed' : ''}`}
                  onClick={() => setOpenTab(idx + 1)}
                >
                  <div className="step-icon-wrapper">
                    {step.icon}
                  </div>
                  <span className="step-label">{step.title}</span>
                </div>
              ))}
            </div>

            <div className="mt-8">
              {/* Floating Preview FAB */}
              <div className="preview-fab" onClick={() => setIsPreviewOpen(true)}>
                <FaEye />
              </div>

              {/* Preview Modal */}
              <Modal
                open={isPreviewOpen}
                onClose={() => setIsPreviewOpen(false)}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                  backdrop: {
                    timeout: 500,
                  },
                }}
              >
                <Fade in={isPreviewOpen}>
                  <Box sx={{
                    ...style,
                    width: 'auto',
                    maxWidth: '90vw',
                    maxHeight: '90vh',
                    borderRadius: '24px',
                    p: 4,
                    background: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                  }}>
                    <div className="flex justify-between w-full mb-4 px-2">
                      <h2 className="text-2xl font-bold">Wheel Preview</h2>
                      <button onClick={() => setIsPreviewOpen(false)} className="text-gray-500 hover:text-black transition-all">
                        <FaTimes size={24} />
                      </button>
                    </div>
                    <div className="bg-gray-50 p-8 rounded-3xl items-center flex justify-center shadow-inner">
                      <Wheels
                        data={renderTimes.length > 0 ? renderTimes.map(obj => ({ option: obj.name || "Reward" })) : [{ option: "Example Reward" }]}
                        backgroundColor={["#6366f1", "#a855f7", "#3b82f6", "#10b981", "#f59e0b", "#ef4444"]}
                        textColors={["#ffffff"]}
                        outerBorderColor="#e2e8f0"
                        fontSize={14}
                      />
                    </div>
                    <div className="mt-6 text-center text-gray-500">
                      <p className="text-sm">This is a real-time preview of your wheel segments</p>
                    </div>
                  </Box>
                </Fade>
              </Modal>

              <div className="space-y-6">
                <div className="tab-content tab-space">
                  <div className={openTab === 1 ? "block" : "hidden"} id="link1">
                    <form className="">
                      <div className="w-full  flex justify-center space-x-3">
                        <div className="mb-2 w-1/2">
                          <div className="w-full">
                            <InputComponent
                              name={"Title"}
                              type={"text"}
                              value={title}
                              setValue={setTitle}
                              required={true}
                            />
                          </div>
                        </div>

                        <div className="mb-2 w-1/2">
                          <div className="w-full">
                            <MultiSelectComponent
                              title={"Included States*"}
                              selected={states}
                              setSelected={setStates}
                              dataArr={allStates}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="w-full  flex justify-center space-x-3">
                        <div className="mb-2 w-1/3">
                          <div className="w-full">
                            <InputComponent
                              name={"Start Date"}
                              type={"date"}
                              value={startDate}
                              setValue={setStartDate}
                              required={true}
                              maxLength={200}
                            />
                          </div>
                        </div>

                        <div className="mb-2 w-1/3">
                          <div className="w-full">
                            <InputComponent
                              name={"End Date"}
                              type={"date"}
                              value={endDate}
                              setValue={setEndDate}
                              required={true}
                              maxLength={200}
                            />
                          </div>
                        </div>

                        <div className="mb-2 w-1/3">
                          <div className="w-full">
                            <InputComponent
                              name={"Budget"}
                              type={"text"}
                              value={budget}
                              setValue={setBudget}
                              required={true}
                            />
                          </div>
                        </div>
                        <div className="mb-2 w-1/3 ">
                          <SelectComponent
                            title={"Feedback Form"}
                            selected={selectedType}
                            setSelected={setSelectedType}
                            dataArr={type}
                            required={true}
                          />
                        </div>
                      </div>

                      <div className="mb-2 w-full">
                        <InputComponent
                          name={"Description"}
                          type={"textarea"}
                          value={description}
                          setValue={setDescription}
                          required={true}
                          maxLength={200}
                        />
                      </div>

                      {(selectedType.id == 2 || selectedType.id == 3) && (
                        <div>
                          <div className="border-gray-300 shadow-sm">
                            <div className="row">
                              <div>
                                <Modal
                                  aria-labelledby="transition-modal-title"
                                  aria-describedby="transition-modal-description"
                                  open={open}
                                  onClose={handleClose}
                                  closeAfterTransition
                                  BackdropComponent={Backdrop}
                                  BackdropProps={{
                                    timeout: 500,
                                  }}
                                >
                                  <Fade in={open}>
                                    <Box sx={style}>
                                      <Typography
                                        id="transition-modal-title"
                                        variant="h6"
                                        component="h2"
                                      >
                                        Preview
                                      </Typography>
                                      {elements.map((element, idx) => {
                                        return element.type === "select" ? (
                                          <div
                                            className="col-md-12 my-2"
                                            key={idx}
                                          >
                                            <div className="d-flex my-1">
                                              <span className="p-2">
                                                {element.label}{" "}
                                              </span>
                                            </div>
                                            <select className="my-2 py-1">
                                              <option value={"Select Options"}>
                                                Select Options
                                              </option>

                                              {element.options.map((opt) => (
                                                <option value={opt}>{opt}</option>
                                              ))}
                                            </select>
                                          </div>
                                        ) : (
                                          <div
                                            className="col-md-12 my-2"
                                            key={idx}
                                          >
                                            <div className="d-flex my-1">
                                              <span className="p-2">
                                                {element.label}{" "}
                                              </span>
                                            </div>
                                            <input
                                              className="form-control"
                                              type={element.type}
                                              maxLength={element.maxLength}
                                              placeholder={element.label}
                                              required={element.required}
                                            />
                                          </div>
                                        );
                                      })}
                                    </Box>
                                  </Fade>
                                </Modal>
                              </div>

                              <div className="mt-2 col-lg-12 grid-margin stretch-card chng_crd">
                                <div className="">
                                  <h2 className="text-capitalize font-bold text-lg p-2">
                                    Update Feedback Form
                                  </h2>
                                  <div className="card-body">
                                    <div className="cmxform " id="feedbackForm">
                                      <div className="form-group ">
                                        <div>
                                          <label className="text-capitalize font-semibold">
                                            New Input
                                          </label>
                                        </div>
                                        <div className="d-flex form_feed ">
                                          <label>
                                            <input
                                              type="text"
                                              className="border p-2 wdt"
                                              placeholder="Add Name"
                                              value={name}
                                              onChange={(e) =>
                                                setName(e.target.value)
                                              }
                                            />
                                          </label>
                                          <label>
                                            <input
                                              type="text"
                                              className="border p-2 wdt"
                                              placeholder="Add Label Name"
                                              value={lableName}
                                              onChange={(e) =>
                                                setLableName(e.target.value)
                                              }
                                            />
                                          </label>
                                          <label>
                                            <input
                                                type="text"
                                                inputMode="numeric"
                                                pattern="[0-9]*"
                                              className="border p-2 wdt1"
                                              placeholder="Max Length"
                                              value={inputLength}
                                              onChange={(e) =>
                                                setInputLength(e.target.value)
                                              }
                                            />
                                          </label>
                                          <label>
                                            <select
                                              className="border p-2 wdt"
                                              value={inputType}
                                              onChange={(e) =>
                                                handleInputTypeChange(e)
                                              }
                                            >
                                              <option value={""}>
                                                Select Type
                                              </option>
                                              <option value={"text"}>Text</option>
                                              <option value={"textarea"}>
                                                Textarea
                                              </option>
                                              <option value={"number"}>
                                                Number
                                              </option>
                                              <option value={"date"}>Date</option>
                                              <option value={"file"}>File</option>
                                              <option value={"checkbox"}>
                                                Checkbox
                                              </option>
                                              <option value={"select"}>
                                                Options
                                              </option>
                                            </select>
                                          </label>

                                          {inputType === "select" ? (
                                            <label>
                                              {selectOption.map((key) => (
                                                <label key={key}>
                                                  <span
                                                    className="px-2 py-2 mx-2 btn btn-outline-danger"
                                                    onClick={(e) =>
                                                      removeFromSelectOptions(
                                                        e,
                                                        key,
                                                      )
                                                    }
                                                  >
                                                    {key}
                                                  </span>
                                                </label>
                                              ))}

                                              <input
                                                type="text"
                                                className="border p-2 wdt1"
                                                placeholder="Add new option"
                                                value={newUserValue}
                                                onChange={(e) =>
                                                  setNewUserValue(e.target.value)
                                                }
                                                onKeyDown={(e) => {
                                                  if (e.keyCode == 13) {
                                                    let oldUserTypes = [
                                                      ...selectOption,
                                                    ];
                                                    oldUserTypes.push(
                                                      newUserValue,
                                                    );
                                                    setSelectOptions(
                                                      oldUserTypes,
                                                    );
                                                    setNewUserValue("");
                                                  }
                                                }}
                                              />
                                            </label>
                                          ) : (
                                            <label></label>
                                          )}
                                          <label className="d-flex">
                                            <input
                                              type="checkbox"
                                              className="px-1 py-1"
                                              checked={required ? "checked" : ""}
                                              onChange={() =>
                                                setRequired(!required)
                                              }
                                            />{" "}
                                            <span className="px-1 py-1 ">
                                              Required
                                            </span>
                                          </label>

                                          <button
                                            type="button"
                                            className="btn btn-outline-primary mtms"
                                            onClick={() => {
                                              setReRender(!reRender);
                                            }}
                                          >
                                            Add
                                          </button>
                                        </div>

                                        {elements.map((element, idx) => {
                                          return element.type === "select" ? (
                                            <div
                                              className="my-2 show_wt"
                                              key={idx}
                                            >
                                              <div className="d-flex my-1 justify-between">
                                                <span className="text_show">
                                                  {element.label}{" "}
                                                </span>
                                                <span
                                                  className="close_show text-danger"
                                                  onClick={(e) =>
                                                    handleDeleteElement(e, idx)
                                                  }
                                                >
                                                  x
                                                </span>{" "}
                                              </div>
                                              <select className="selctws ">
                                                <option value={"Select Options"}>
                                                  Select Options
                                                </option>

                                                {element.options.map((opt) => (
                                                  <option value={opt}>
                                                    {opt}
                                                  </option>
                                                ))}
                                              </select>
                                            </div>
                                          ) : (
                                            <div
                                              className="show_wt my-2"
                                              key={idx}
                                            >
                                              <div className="d-flex my-1 justify-between">
                                                <span className="text_show">
                                                  {element.label}{" "}
                                                </span>
                                                <span
                                                  className="close_show text-danger"
                                                  onClick={(e) =>
                                                    handleDeleteElement(e, idx)
                                                  }
                                                >
                                                  x
                                                </span>
                                              </div>

                                              <input
                                                className="form-control ckbox_show"
                                                type={element.type}
                                                maxLength={element.maxLength}
                                                placeholder={element.label}
                                                required={element.required}
                                              />
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="flex justify-between items-center mt-8 pt-6 border-t border-gray-100">
                        <button
                          className="inline-flex items-center gap-2 px-6 py-3 rounded-xl font-bold text-gray-500 bg-gray-100 hover:bg-gray-200 transition-all opacity-50 cursor-not-allowed"
                          disabled
                        >
                          <FaChevronLeft /> Previous
                        </button>
                        <button
                          className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-bold text-white bg-indigo-600 hover:bg-indigo-700 shadow-lg shadow-indigo-200 transition-all hover:scale-105"
                          onClick={(e) => {
                            e.preventDefault();
                            if (!edit && !wc_id) {
                              // New wheel: register campaign first, wc_id is set
                              // and tab advances to 2 inside the useEffect
                              handleCreateWheelCampaign(e);
                            } else {
                              // Edit mode or campaign already created
                              setOpenTab(2);
                            }
                          }}
                        >
                          Next Step <FaChevronRight />
                        </button>
                      </div>
                    </form>
                  </div>
                  <div className={openTab === 2 ? "block" : "hidden"} id="link2">
                    <form className="">
                      <div className="flex  w-full">
                        <div className="w-1/2">
                          <div className="mb-6">
                            <SelectComponent
                              title={"No. of Rewards*"}
                              selected={reward}
                              setSelected={setReward}
                              dataArr={rewardLengths}
                            />
                          </div>

                          <div className="mb-6">
                            <SelectComponent
                              title={"Wheel Type"}
                              selected={wheelType}
                              setSelected={setWheelType}
                              dataArr={wheelTypes}
                            />
                          </div>

                          <div className="mb-6">
                            {rewardsSbmt == false && wheelType.id == "2" && (
                              <>
                                <SelectComponent
                                  title={"Fixed Wheel Reward"}
                                  selected={fixedReward}
                                  setSelected={setFixedReward}
                                  dataArr={renderTimes.length > 0 ? renderTimes : []}
                                />
                              </>
                            )}
                          </div>

                          {/* 
                        <div className="w-full  flex justify-center space-x-3">
                          <div className="mb-3 w-1/2">
                            <div className="w-full">
                              <label
                                htmlFor="primaryBackgroundColour"
                                className="block text-sm font-medium leading-6 text-gray-900 mb-0"
                              >
                                Background Colour
                              </label>
                              <input
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
                                type="color"
                                value={primaryBackgroundColor}
                                onChange={handlePrimaryBackgroundColorChange}
                              />
                              <input
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
                                type="text"
                                value={primaryBackgroundColor}
                                onChange={handlePrimaryBackgroundColorChange}
                              />
                            </div>
                          </div>

                          <div className="mb-3 w-1/2">
                            <div className="w-full">
                              <label
                                htmlFor="secondaryBackgroundColour"
                                className="block text-sm font-medium leading-6 text-gray-900 mb-0"
                              >
                                Secondary Background Colour
                              </label>
                              <input
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
                                type="color"
                                value={secondaryBackgroundColor}
                                onChange={handleSecondaryBackgroundColorChange}
                              />
                              <input
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
                                type="text"
                                value={secondaryBackgroundColor}
                                onChange={handleSecondaryBackgroundColorChange}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="w-full  flex justify-center space-x-3">
                          <div className="mb-3 w-1/2">
                            <div className="w-full">
                              <label
                                htmlFor="fontSize"
                                className="block text-sm font-medium leading-6 text-gray-900 mb-0"
                              >
                                Font Size
                              </label>
                              <input
                                type="number"
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
                                value={fontSize}
                                onChange={handleFontChange}
                              />
                            </div>
                          </div>

                          <div className="mb-3 w-1/2">
                            <div className="w-full">
                              <label
                                htmlFor="secondaryBackgroundColour"
                                className="block text-sm font-medium leading-6 text-gray-900 mb-0"
                              >
                                Font Colour
                              </label>
                              <input
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
                                type="color"
                                value={primaryTextColor}
                                onChange={handlePrimaryTextColorChange}
                              />
                              <input
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
                                type="text"
                                value={primaryTextColor}
                                onChange={handlePrimaryTextColorChange}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="w-full  flex justify-center space-x-3">
                          <div className="mb-3 w-1/2">
                            <div className="w-full">
                              <label
                                htmlFor="secondaryBackgroundColour"
                                className="block text-sm font-medium leading-6 text-gray-900 mb-0"
                              >
                                Secondary Font Colour
                              </label>
                              <input
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
                                type="color"
                                value={secondaryTextColor}
                                onChange={handleSecondaryTextColorChange}
                              />
                              <input
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
                                type="text"
                                value={secondaryTextColor}
                                onChange={handleSecondaryTextColorChange}
                              />
                            </div>
                          </div>

                          <div className="mb-3 w-1/2">
                            <div className="w-full">
                              <label
                                htmlFor="lineColour"
                                className="block text-sm font-medium leading-6 text-gray-900 mb-0"
                              >
                                Line Colour
                              </label>
                              <input
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
                                type="color"
                                value={outerBorderColor}
                                onChange={(e) => {
                                  setOuterBorderColor(e.target.value);
                                }}
                              />
                              <input
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
                                type="text"
                                value={outerBorderColor}
                                onChange={(e) => {
                                  setOuterBorderColor(e.target.value);
                                }}
                              />
                            </div>
                          </div>
                        </div> */}

                          {/* {userTypes && (
                          <div className="mb-6 select_mlt">
                            <InputLabel>User Types*</InputLabel>
                            <Select
                              className=" shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full min-h-0  "
                              multiple
                              value={names}
                              onChange={(e) => {
                                setUserNames(e.target.value);
                              }}
                              input={<OutlinedInput label="Multiple Select" />}
                            >
                              {userTypes.map((e) => (
                                <MenuItem key={e.name} value={e}>
                                  {e.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </div>
                        )} */}

                          {
                            <div className="w-full mb-6">
                              <MultiSelectComponent
                                title={"Select User Types States"}
                                required={true}
                                selected={names}
                                setSelected={setUserNames}
                                dataArr={
                                  userTypes && userTypes.length > 0
                                    ? userTypes
                                    : []
                                }
                              />
                            </div>
                          }

                          <div class="w-full">
                            <div className="borderbox_upl shadow-sm">
                              <h2 className="mb-2">Upload Wheel Image</h2>
                              <div class="input-group mb-3 px-2 py-2 w-full border-2 rounded-pill bg-white shadow-sm d-flex justify-content-center align-items-center">
                                <input
                                  id="upload-login"
                                  type="file"
                                  accept="image/*"
                                  onChange={(e) => {
                                    // setThumbnailLogo(URL.createObjectURL(e.target.files[0]));
                                    setPictureFile(e.target.files);
                                  }}
                                  class="form-control border-0"
                                  style={{ display: "none" }}
                                />
                                {/* <label for="upload-login" class="font-weight-light">Choose file</label> */}
                                <div class="input-group-append w-full text-center">
                                  <label
                                    for="upload-login"
                                    class="btn btn-light m-0 rounded-pill px-4 d-flex align-items-center w-full  justify-center "
                                  >
                                    <FaCloudUploadAlt class="mr-2" />
                                    <small class="text-uppercase text-truncate font-weight-bold text-muted">
                                      Choose file :{" "}
                                      <span className="font-weight-light text-truncate text-black text-center">
                                        {pictureFile &&
                                          pictureFile.length > 0 &&
                                          pictureFile[0].name.slice(0, 10)}
                                      </span>
                                    </small>
                                  </label>
                                </div>
                              </div>
                              {pictureFile && pictureFile.length > 0 && (
                                <>
                                  {uploadImageIsLoading ? (
                                    <div
                                      class="spinner-border text-dark"
                                      role="status"
                                    >
                                      <span class="sr-only">Loading...</span>
                                    </div>
                                  ) : (
                                    <button
                                      className="btn btn-primary mb-2 "
                                      onClick={() =>
                                        uploadImageFunc(pictureFile, 0)
                                      }
                                    >
                                      Upload
                                    </button>
                                  )}
                                  <p class="font-italic text-black text-center">
                                    The image uploaded will be rendered below.
                                  </p>
                                </>
                              )}

                              <div class="image-area my-2 w-20 imgcn1 ">
                                <img
                                  id="imageResult"
                                  src={picture ? picture : ""}
                                  alt=""
                                  class="img-fluid"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* <div className="w-1/2 bg-gray-50 rounded-lg flex justify-center items-center m-3">
                        <Wheels
                          data={data}
                          // backgroundColor={backgroundColor}
                          // textColors={textColors}
                          // outerBorderColor={outerBorderColor}
                          // fontSize={fontSize}
                        />
                      </div> */}
                      </div>
                      {!edit ? (
                        <div className="flex justify-center mt-4">
                          <button
                            type="submit"
                            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5  "
                            onClick={handleAddWheel}
                          >
                            Add
                          </button>
                        </div>
                      ) : (
                        <div className="flex justify-center mt-4">
                          <button
                            type="submit"
                            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5  "
                            onClick={updateWheel}
                          >
                            Update
                          </button>
                        </div>
                      )}
                    </form>
                  </div>

                  <div className={openTab === 3 ? "block" : "hidden"} id="link3">
                    <form className="my-2">
                      {/* <div className="bg-gray-50 rounded-lg mb-3 p-3">
                      <Wheels
                        data={data}
                        // backgroundColor={backgroundColor}
                        // textColors={textColors}
                        // outerBorderColor={outerBorderColor}
                        // fontSize={fontSize}
                      />
                    </div> */}
                      {renderTimes.map((obj, index) => (
                        <div key={index} className="segment-card">
                          <div className="segment-header">
                            <h3 className="text-lg font-bold flex items-center gap-2">
                              <span className="w-8 h-8 rounded-full bg-indigo-600 text-white flex items-center justify-center text-sm">
                                {index + 1}
                              </span>
                              Segment Details
                            </h3>
                            <div className="flex items-center gap-2">
                              <span className={`text-xs px-2 py-1 rounded-full ${obj.status == "1" ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-500"}`}>
                                {obj.status == "1" ? "Active" : "Inactive"}
                              </span>
                            </div>
                          </div>

                          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-6">
                            <div className="flex flex-col gap-1">
                              <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Type*</label>
                              <select
                                className="god-input h-11"
                                value={obj.type}
                                onChange={(e) => stateChange(index, "type", e.target.value)}
                                required
                              >
                                <option value="">Select Type...</option>
                                {types.map((option) => (
                                  <option key={option.id} value={option.name}>
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                            </div>

                            {obj.type === "Coupon" && (
                              <div className="flex flex-col gap-1">
                                <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Coupon Provider*</label>
                                <select
                                  className="god-input h-11"
                                  value={obj.name}
                                  onChange={(e) => stateChange(index, "name", e.target.value)}
                                  required
                                >
                                  <option value="">Select Provider...</option>
                                  {couponList.map((option) => (
                                    <option key={option.id} value={option.name}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}

                            <div className="flex flex-col gap-1">
                              <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Display Name*</label>
                              <input
                                className="god-input h-11"
                                type="text"
                                value={obj.name || (obj.type === "Filler" ? "Better Luck Next Time" : "")}
                                required
                                onChange={(e) => {
                                  stateChange(index, "name", e.target.value);
                                  const updatedData = [...data];
                                  updatedData[index].name = e.target.value;
                                  setData(updatedData);
                                }}
                              />
                            </div>

                            <div className="flex flex-col gap-1">
                              <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Status*</label>
                              <select
                                className="god-input h-11"
                                value={obj.status}
                                onChange={(e) => stateChange(index, "status", e.target.value)}
                                required
                              >
                                <option value="">Select Status...</option>
                                {status.map((option) => (
                                  <option key={option.id} value={option.id}>
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="flex flex-col gap-1">
                              <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Price</label>
                              <input
                                className="god-input h-11"
                                type="text"
                                inputMode="numeric"
                                value={obj.price}
                                onChange={(e) => {
                                  const v = e.target.value;
                                  if (v === "" || /^\d*\.?\d*$/.test(v)) {
                                    stateChange(index, "price", v);
                                  }
                                }}
                              />
                            </div>

                          </div>
                          <div className=" w-1/6">
                            {obj.image && <img src={obj.image} alt={obj.windex} className="img-fluid flex items-center justify-center w-20 m-auto " />}
                          </div>
                          {obj.type === "Point" && (
                            <div className="mb-6 w-1/6">
                              <label htmlFor="">Points</label>
                              <input
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
                                type="text"
                                inputMode="numeric"
                                value={obj.points}
                                onChange={(e) => {
                                  const v = e.target.value;
                                  if (v === "" || /^\d*$/.test(v)) {
                                    stateChange(index, "points", v);
                                  }
                                }}
                              />
                            </div>
                          )}
                        </div>
                      ))}

                      <div className="flex justify-between items-center mt-10 pt-8 border-t border-gray-100">
                        <button
                          className="inline-flex items-center gap-2 px-6 py-3 rounded-xl font-bold text-gray-600 bg-gray-100 hover:bg-gray-200 transition-all hover:translate-x-[-2px]"
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenTab(2);
                          }}
                        >
                          <FaChevronLeft /> Previous
                        </button>
                        <div className="flex gap-4">
                          <button
                            type="button"
                            onClick={openTab == 3 && rewardsSbmt ? handleAddRewards : updateWheelRewards}
                            className="px-8 py-3 rounded-xl font-bold text-white bg-indigo-600 hover:bg-indigo-700 shadow-lg shadow-indigo-200 transition-all hover:scale-105"
                          >
                            {rewardsSbmt ? "Save Rewards" : "Update Rewards"}
                          </button>
                          <button
                            type="button"
                            className="inline-flex items-center gap-2 px-8 py-3 rounded-xl font-bold text-white bg-purple-600 hover:bg-purple-700 shadow-lg shadow-purple-200 transition-all hover:scale-105"
                            onClick={(e) => {
                              e.preventDefault();
                              setOpenTab(4);
                            }}
                          >
                            Next: Allocations <FaChevronRight />
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className={openTab === 4 ? "block" : "hidden"} id="link4">
                    <form className="my-2">
                      <div className="space-y-4">
                        {allocationData.map((obj, index) => {
                          const rewardData = renderTimes.find(r => r.windex === obj.windex) || {};
                          return (
                            <div key={index} className="segment-card !p-5">
                              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6 items-end">
                                <div className="flex flex-col gap-1">
                                  <label className="text-xs font-black text-gray-400 uppercase tracking-widest">Reward Name</label>
                                  <div className="h-11 flex items-center px-4 bg-indigo-50 text-indigo-700 rounded-xl font-bold border border-indigo-100">
                                    {rewardData.name}
                                  </div>
                                </div>

                                <div className="flex flex-col gap-1">
                                  <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Probability %*</label>
                                  <input
                                    type="text"
                                    inputMode="decimal"
                                    className="god-input h-11"
                                    value={rewardData.probability || 0}
                                    onChange={(e) => {
                                      const v = e.target.value;
                                      if ((v === "" || /^\d*\.?\d*$/.test(v)) && Number(v) <= 100) {
                                        stateChange(obj.windex, "probability", v);
                                      }
                                    }}
                                  />
                                </div>

                                <div className="flex flex-col gap-1">
                                  <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Start Date*</label>
                                  <input
                                    type="date"
                                    className="god-input h-11"
                                    value={rewardData.startDate || ""}
                                    onChange={(e) => stateChange(obj.windex, "startDate", e.target.value)}
                                  />
                                </div>

                                <div className="flex flex-col gap-1">
                                  <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">End Date*</label>
                                  <input
                                    type="date"
                                    className="god-input h-11"
                                    value={rewardData.endDate || ""}
                                    onChange={(e) => stateChange(obj.windex, "endDate", e.target.value)}
                                  />
                                </div>
                              </div>

                              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 items-end mt-4">
                                <div className="flex flex-col gap-1">
                                  <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">State Targeting</label>
                                  <MultiSelectComponent
                                    title={"Select States"}
                                    selected={Array.isArray(obj.state) ? obj.state : []}
                                    setSelected={(val) => handleAllocationChange(index, "state", val)}
                                    dataArr={[{ id: 0, name: "Random" }, ...allStates]}
                                    required={false}
                                  />
                                </div>

                                <div className="flex flex-col gap-1">
                                  <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Total Stock</label>
                                  <input
                                    type="text"
                                    inputMode="numeric"
                                    className="god-input h-11"
                                    value={obj.total}
                                    onChange={(e) => {
                                      const v = e.target.value;
                                      if (v === "" || /^\d*$/.test(v)) {
                                        handleAllocationChange(index, "total", v);
                                      }
                                    }}
                                  />
                                </div>

                                <div className="flex flex-col gap-1">
                                  <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Available</label>
                                  <input
                                    type="text"
                                    inputMode="numeric"
                                    className="god-input h-11"
                                    value={obj.available}
                                    onChange={(e) => {
                                      const v = e.target.value;
                                      if (v === "" || /^\d*$/.test(v)) {
                                        handleAllocationChange(index, "available", v);
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>

                      <div className="flex justify-between items-center mt-10 pt-8 border-t border-gray-100">
                        <button
                          className="inline-flex items-center gap-2 px-6 py-3 rounded-xl font-bold text-gray-600 bg-gray-100 hover:bg-gray-200 transition-all hover:translate-x-[-2px]"
                          onClick={(e) => {
                            e.preventDefault();
                            setOpenTab(3);
                          }}
                        >
                          <FaChevronLeft /> Back to Rewards
                        </button>
                        <button
                          type="button"
                          className="px-10 py-4 rounded-2xl font-black text-lg text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 shadow-xl shadow-indigo-200 transition-all hover:scale-105 active:scale-95"
                          onClick={handleFinish}
                        >
                          Publish Campaign
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Wheel;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
